export default __webpack_public_path__ + "static/logo_white-80c4b8dcd838f9d47593f3e11949dfdd.png";